namespace Areas {
    "use strict";

    export function addButtonsToTreeListToolbar(buttonOptions: Array<string>, addOtherButtons: (e: any) => void = null) {
        return (e: any) => {
            if (_.contains(buttonOptions, "columnChooser")) {
                TreeList.addColumnChooser(e);
            }

            if (isIE11()) {
                disableStateStoring(e);
            }

            if (_.contains(buttonOptions, "resetLayout")) {
                TreeList.addResetLayout(e);
            }

        }
    }

    function disableStateStoring(e: any) {
        const grid: DevExpress.ui.dxTreeList = e.component;
        grid.option('stateStoring.enabled', false);
    }
}